import React from "react";
import { JobFeedForm, SubmitTypes } from "components/JobFeed/JobFeedForm";
import { generatePath, useHistory } from "react-router-dom";
import routes from "utils/routes";
import { jobFeedRepository } from "domain/repository";
import dayjs from "dayjs";

type Props = {
  isAgency: boolean;
  storeId: string | undefined;
};

export const NewForm: React.FC<Props> = ({ isAgency, storeId }) => {
  const history = useHistory();

  return (
    <JobFeedForm
      initialValues={{
        url: "",
        title: "",
        company: "",
        jobType: "full_time",
        description: "",
        postDate: dayjs().toDate(),
        salaryType: "hour",
        salaryMin: 1000,
        salaryMax: 1000,
        state: null,
        city: null,
        address: null,
        station: null,
        experience: null,
        workingTime: null,
        imageUrl: null,
      }}
      isAgency={isAgency}
      storeId={storeId}
      handleSubmit={({ values, setStatus, resetForm }) => {
        jobFeedRepository
          .create(isAgency, storeId, values)
          .then(() => {
            resetForm();
            const jobFeedIndex = isAgency
              ? generatePath(routes.agency.jobFeedIndex.pathname, {
                  storeId,
                })
              : routes.store.jobFeedIndex;
            history.push(jobFeedIndex);
          })
          .catch((e) => {
            if (e.response.status === 422) {
              setStatus({ success: "", error: e.response.data.message });
            } else {
              setStatus({ success: "", error: "更新に失敗しました" });
            }
          });
      }}
      submitType={SubmitTypes.CREATE}
    />
  );
};
